import React, {Component} from "react";
import {Link} from "react-router-dom";

class Card extends Component {
    constructor() {
        super();
        this.state = {clicked: false};
    }

    render() {
        const {sampleRequirement, handleChange} = this.props;
        return (
            <div className="card" onClick={() => handleChange(sampleRequirement.requirement)}>
                <div className="card-content">
                    {sampleRequirement.requirement}
                </div>
                {/*<div className="card-overlay" >*/}
                {/*    <img className="copy" src={process.env.PUBLIC_URL + '/Copy.png'}  alt="COPY"/>*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default Card;
